import { Outlet, NavLink } from "react-router-dom";
import { Box, Text, Flex, ScrollArea } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";
import {
  RocketIcon,
  ArchiveIcon,
  UploadIcon,
  CubeIcon,
  BookmarkIcon,
  BackpackIcon,
  HomeIcon,
  LayersIcon,
  GlobeIcon,
  PersonIcon,
  AvatarIcon,
  CalendarIcon,
  IdCardIcon,
  MixIcon,
} from "@radix-ui/react-icons";
import styles from "./ManageLayout.module.css";

interface MenuSection {
  titleKey: string;
  items: {
    labelKey: string;
    path: string;
    icon: React.ReactNode;
  }[];
}

const menuSections: MenuSection[] = [
  {
    titleKey: "menu.activities",
    items: [
      {
        labelKey: "menu.marketingActivities",
        path: "/manage/marketing-activities",
        icon: <RocketIcon />,
      },
      {
        labelKey: "menu.storeActivities",
        path: "/manage/store-activities",
        icon: <ArchiveIcon />,
      },
      {
        labelKey: "menu.import",
        path: "/manage/import",
        icon: <UploadIcon />,
      },
      {
        labelKey: "menu.periods",
        path: "/manage/periods",
        icon: <CalendarIcon />,
      },
    ],
  },
  {
    titleKey: "menu.catalog",
    items: [
      {
        labelKey: "menu.products",
        path: "/manage/products",
        icon: <CubeIcon />,
      },
      {
        labelKey: "menu.brands",
        path: "/manage/brands",
        icon: <BookmarkIcon />,
      },
      {
        labelKey: "menu.suppliers",
        path: "/manage/suppliers",
        icon: <BackpackIcon />,
      },
    ],
  },
  {
    titleKey: "menu.stores",
    items: [
      {
        labelKey: "menu.stores",
        path: "/manage/stores",
        icon: <HomeIcon />,
      },
      {
        labelKey: "menu.banners",
        path: "/manage/banners",
        icon: <IdCardIcon />,
      },
      {
        labelKey: "menu.storeSets",
        path: "/manage/store-sets",
        icon: <LayersIcon />,
      },
    ],
  },
  {
    titleKey: "menu.assignments",
    items: [
      {
        labelKey: "menu.agencies",
        path: "/manage/agencies",
        icon: <MixIcon />,
      },
      {
        labelKey: "menu.territories",
        path: "/manage/territories",
        icon: <GlobeIcon />,
      },
      {
        labelKey: "menu.reps",
        path: "/manage/reps",
        icon: <AvatarIcon />,
      },
    ],
  },
  {
    titleKey: "menu.users",
    items: [
      {
        labelKey: "menu.manageUsers",
        path: "/manage/users",
        icon: <PersonIcon />,
      },
      {
        labelKey: "menu.auditors",
        path: "/manage/auditors",
        icon: <AvatarIcon />,
      },
    ],
  },
];

export function ManageLayout() {
  const { t } = useTranslation();

  return (
    <Flex className={styles.container}>
      <Box className={styles.sidebar}>
        <ScrollArea>
          <Box p="3">
            {menuSections.map((section) => (
              <Box key={section.titleKey} mb="4">
                <Text
                  size="1"
                  weight="bold"
                  color="gray"
                  className={styles.sectionTitle}
                >
                  {t(section.titleKey)}
                </Text>
                <Flex direction="column" gap="1" mt="2">
                  {section.items.map((item) => (
                    <NavLink
                      key={item.path}
                      to={item.path}
                      className={({ isActive }) =>
                        `${styles.menuItem} ${isActive ? styles.active : ""}`
                      }
                    >
                      <Flex align="center" gap="2">
                        {item.icon}
                        <Text size="2">{t(item.labelKey)}</Text>
                      </Flex>
                    </NavLink>
                  ))}
                </Flex>
              </Box>
            ))}
          </Box>
        </ScrollArea>
      </Box>
      <Box className={styles.content}>
        <Outlet />
      </Box>
    </Flex>
  );
}
